









































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KEDrawer',
  props: {
    isOpen: { type: Boolean, default: false },
    maxWidth: { type: String, default: '485px' },
    isLoading: { type: Boolean, default: false },
    mobilePeekGap: { type: String, default: '0px' }
  },
  setup(_, { emit }) {
    const handleClose = () => {
      emit('close');
    };

    let clickedOnDrawer = false;
    const handleDrawerMouseDown = () => {
      clickedOnDrawer = true;
    };

    const handleOverlayMouseUp = () => {
      if (clickedOnDrawer) {
        clickedOnDrawer = false;
      } else {
        emit('close');
      }
    };

    return {
      handleClose,
      handleDrawerMouseDown,
      handleOverlayMouseUp
    };
  }
});
